export default __webpack_public_path__ + "static/media/margot.5da2dc06.jpg";